import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { AvailableDateSettingRecord } from '../entities/records';
import * as selectors from '../entities/AvailableDateSetting/selectors';

function mapStateToProps(state, { availableDateSettingId }) {
  return {
    availableDateSetting: selectors.availableDateSettingById(state, availableDateSettingId),
  };
}

export default compose(
  setPropTypes({
    availableDateSettingId:
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
  }),
  connect,
  setPropTypes({
    availableDateSetting: PropTypes.instanceOf(AvailableDateSettingRecord),
  }),
)(mapStateToProps);
